import { IPhoneNumber } from "../vue-interfaces/i-phone-number";
import { IAddress } from "../vue-interfaces/i-address";
import { Address } from "./address";

export class DMEVendor {
    public id: string;
    public name: string;
    public vendorType: number;
    public address: IAddress = new Address();
    public primaryPhone: IPhoneNumber;
    public secondaryPhone: IPhoneNumber;
    public tertiaryPhone: IPhoneNumber;
    public contactFirstName?: string;
    public contactLastName?: string;
    public email: string;
    public faxNumber: string;
    public comment: string;
    public medicareContractNumber: string;
    public medicaidContractNumber: string;
    public isContract: boolean;
    public npi: string;
    public insuranceContracts: string;
    public communityLiaisonId: string;
    public communityLiaisonName: string;

    public constructor(data?: DMEVendor) {
        if (data) {
            Object.assign(this, data);
            this.address = new Address(this.address);
        }
    }
}
